// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","secondary":"#3F4E88","highlight":"#B8DFF0","secondary_alt":"#4F45E5","large_desktop":"only screen and (min-width: 1201px)","desktop":"only screen and (min-width: 1025px) and (max-width: 1200px)","tablet":"only screen and (min-width: 768px) and (max-width: 1024px)","mobile":"only screen and (max-width: 767px)","small_mobile":"only screen and (max-width: 374px)","nameLogo":"nameLogo__1lCc0","nav":"nav__FTJ6X","navBarLeft":"navBarLeft__2taJb","navBarRight":"navBarRight__2Dt6e","burgerMenu":"burgerMenu__3qclf"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/style.css
// module id = A8Bg
// module chunks = 0